import { fromJS } from 'immutable';

import generateHandleActions from 'redux/state-handler';
import { STORE_NOTIFICATIONS_LIST, APP_NOTIFICATIONS_LIST, MARK_NOTIFICATION_AS_READ } from 'redux/constants';

const apiStates = [
  { type: STORE_NOTIFICATIONS_LIST, name: 'store', clear: true },
  { type: APP_NOTIFICATIONS_LIST, name: 'app', clear: true },
];

const instantStates = [];
const storage = {};
const listValues = ['store', 'app'];

const updateNotifications = (state, { payload: { data: { type } } }) => {
  switch (type) {
    case 'store':
      return state.setIn([type, 'data'], fromJS([]));
    case 'app':
      return state.setIn([type, 'data', 'unreadCount'], 0);
    default:
      break;
  }
  return state;
};

const customHandlers = {
  [`${MARK_NOTIFICATION_AS_READ}_SUCCESS`]: updateNotifications,
};

export default generateHandleActions({
  apiStates, instantStates, storage, listValues, customHandlers,
});
